import { loadDyPageData as dyPageLoader } from './modules/external-systems/dynamic-yield/ChooseRequest';

dyPageLoader();

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) {
    return;
  }

  const cart =
    document.querySelector('.cart-card-wrapper.open') ||
    document.querySelector('#cart');

  if (!cart) {
    return;
  }

  const loadingContent = cart.querySelector('.cart__content-wrapper.loading');
  const loadingCheckout = cart.querySelector(
    'button[name="checkout"].gld-btn--loading'
  );

  if (loadingContent) {
    loadingContent.classList.remove('loading');
  }

  if (loadingCheckout) {
    loadingCheckout.classList.remove('gld-btn--loading');
  }
});
